import type { DashboardTemplate } from './dashboardTemplate.types';

// Six components: three totals cards over a line chart, a bar chart and a pie chart.
//
// Chart tiles have no data contract yet, so they render as configuration cards with a neutral
// placeholder. That is the point of this template — it shows what the generator can express before
// the chart endpoints exist.
//
// The wording maps onto the registry deliberately: "over measurement dates" is the special
// `measurement_date` dimension, "over financial periods" is `series_source: financial_periods`, and
// "by company" is `dimension: company_name`, which is a legal dimension even though it is not a
// numeric metric.
export const chartsTemplate: DashboardTemplate = {
  id: 'charts',
  title: 'Performance Trends',
  description: 'KPI cards over time-series charts and a portfolio breakdown.',
  prompt: `Build a performance trends dashboard on a 3-column layout.

Open with three 1x1 totals cards — total value, MOIC and gross IRR — each with an accent bar and a "vs prior period" comparison.

Below them a full-width area line chart of total value over measurement dates, with a legend and a 3M/6M/1Y/ALL time range defaulting to 1Y.

Then a 2-wide bar chart of total revenue and EBITDA over financial periods, beside a 1-wide pie chart of total value by company.`,
  preview: [{ w: 1 }, { w: 1 }, { w: 1 }, { w: 3 }, { w: 2 }, { w: 1 }],
};
